export const ALL_UNDERSCORES = /_/g
export const ALL_COMMAS = /,/g
export const REMOVE_WHITESPACE = /\s+/
export const MORE_THAN_TWO_DECIMAL_PLACES = /\.\d{3,}$/g
export const TWO_OR_MORE_DECIMAL_PLACES = /\.\d{2,}$/g
export const LESS_THAN_TWO_DECIMAL_PLACES = /\.\d{0,1}$/g
export const WORD_OR_WHITESPACE = /^[a-zA-Z0-9 ]*$/gi
export const NOT_LETTER_OR_NUMBER = /[^a-zA-Z0-9]/g
export const ALPHANUMERIC = /^[a-z0-9]+$/i
